import React from 'react';
import PropTypes from 'prop-types';

function IconArrow({ color = '#01FF95', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 4L10 8L6 12" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 4L10 8L6 12" stroke="black" strokeOpacity="0.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  )
}

IconArrow.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconArrow;
